import React from 'react';
import { Checkbox } from '@material-ui/core';
import './CustomTableAssign.scss';

const CustomTableAssign = (props) => {
  const { handleCheckbox, checked, value, capacity, exposure } = props;
  return (
    <div className='custom-table-assign row'>
      <div className='col-md-4'>
        <p className='table-number'>{('0' + value).slice(-2)}</p>
      </div>
      <div className='col-md-1 table-divider' />
      <div className='col-md-6 table-description'>
        <p className='table-description-text'>Capacity : {capacity}</p>
        <p className='table-description-text'>Exposure : {exposure}</p>
      </div>
      <div className='col-md-1 table-checkbox'>
        <Checkbox onClick={(e) => handleCheckbox(e)} defaultChecked={checked} value={value} />
      </div>
    </div>
  );
};

export default CustomTableAssign;
